<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    DrawerMenu(v-if="uid" :uid="uid" :show="showGlobalMenu" @close="toggleMenu")
    div.wrap-settings
      ModuleSettings
</template>

<style lang="scss" scoped>
.wrap-settings {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header.vue'
import DrawerMenu from '@/components/shared/DrawerMenu'
import ModuleSettings from '@/components/module/ModuleSettings'

export default {
  components: {
    Auth, Header, DrawerMenu, ModuleSettings
  },
  data () {
    return {
      headerContent: {
        title: '設定',
        left: {
          icon: 'mdi-menu',
          action: this.toggleMenu 
        }
      },
      showGlobalMenu: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
    },
    toggleMenu () {
      this.showGlobalMenu = !this.showGlobalMenu
    }
  }
}
</script>
